"use strict";

import React from 'react';
import Accounting from "accounting";

const OrderAdjustment = ({adjustment={}, type="credit",}) => {
    return (
        <tr className="order__adjustments__row" style={{borderBottom: '1px solid #dddddd',}}>
            <td className="line-item-action-col">
                &nbsp;
            </td>
            <td className="line-item-quantity-col">
                1
            </td>
            <td className="line-item-description-col" colSpan="3">
                <div className="admin__order__line-item__description__row">
                    <span className="cart__line-item__description__sku-label">{adjustment.category}: </span>
                    <span className="cart__line-item__description__name"
                          style={{display: 'inline-block', verticalAlign: 'middle',}}>
                        {adjustment.description}
                    </span>
                </div>
            </td>
            <td className="line-item-extra-charges-col">
                {type === 'debit' ? Accounting.formatMoney(adjustment.amount) : '\u00A0'}
            </td>
            <td className="line-item-discount-col">
                {type === 'credit' ? Accounting.formatMoney(adjustment.amount) : '\u00A0'}
            </td>
            <td className="line-item-total-col">
                {type === 'credit' ? '-' : ''}
                {Accounting.formatMoney(adjustment.amount)}
            </td>
        </tr>
    );
};

export default OrderAdjustment;